import { render, staticRenderFns } from "./OrderNum.vue?vue&type=template&id=f349ad4c&"
import script from "./OrderNum.vue?vue&type=script&lang=js&"
export * from "./OrderNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports